module.exports = __webpack_public_path__ + "assets/img/xwzg.77730542.jpg";